import {createElement, removeElement} from '../utils/dom.js';
import {positionRelativeTo} from '../utils/positionrelativeto.js';
import {render, html} from '../lib/lit-html.js';

function heading(state){
	return html`
		<div class="ekm-search-recent-searches-heading">
			<div class="ekm-search-recent-searches-heading-text">
				Your recent searches...
			</div>

			<div class="ekm-search-recent-searches-heading-clear">
				Clear All
			</div>		
		</div>
	`;
}

function items(state){
	var activeItem = state.recentQueries.activeItem;
	return html`
		<div class="ekm-search-recent-searches-items">
			${state.recentQueries.items.map((item, index) => {
				var className = "ekm-search-recent-searches-item"
				
				if (item === activeItem){
					className += " ekm-search-recent-searches-item-active"
				}

				return html`
					<div class=${className} data-index=${index}>
						<div class="ekm-search-recent-searches-item-text">
							<i class="shopui-icon shopui-icon-history"></i>
							${item}
						</div>
						<div class="ekm-search-recent-searches-item-clear">
							<i class="shopui-icon shopui-icon-close"></i>
						</div>
					</div>
				`
			})}
		</div>
	`;
}

export class RecentSearchesView {
	constructor(store){
		this._store = store;
		this._visible = false;
		this._element = createElement('div.ekm-search-recent-searches');
		this._element.addEventListener('click', this._onClick.bind(this));
		store.subscribe(this._onStateChange.bind(this));
	}

	_onClick(event){
		if (event.target.closest('.ekm-search-recent-searches-heading-clear')){
			this._store.dispatch({
				type: 'CLEAR_ALL_RECENT_SEARCHES'
			});
			return;
		}

		var el = event.target.closest('.ekm-search-recent-searches-item');

		if (!el) return;

		var index = parseFloat(el.dataset.index);

		if (event.target.closest('.ekm-search-recent-searches-item-clear')){
			this._store.dispatch({
				type: 'CLEAR_RECENT_SEARCH',
				query: this._store.getState().recentQueries.items[index]
			});
			return;
		}

		this._store.dispatch({
			type: 'SELECT_RECENT_SEARCH',
			query: this._store.getState().recentQueries.items[index]
		});
	}

	_onStateChange(state){
		var hasItems = state.recentQueries.items.length > 0;
		var hasActiveElement = state.inputs.activeElement !== null;
		var hasSuggestions = state.suggestions.queries.length > 0;
		var hasPredicted = state.suggestions.items.length > 0

		if (!hasItems || !hasActiveElement || hasSuggestions || hasPredicted){
			if (!this._isVisible) return;
			removeElement(this._element);
			this._isVisible = false;
			return;
		}

		if (!this._isVisible){
			document.body.appendChild(this._element);
			this._isVisible = true;
		}

		render(this._compose(state), this._element);

		this._positionElement(state);
	}

	_compose(state){
		return html`
			${heading(state)}
			${items(state)}
		`;
	}

	_positionElement(state){
		var input = state.inputs.elements[state.inputs.activeElement];

		var anchorSelector = getComputedStyle(input)
			.getPropertyValue('--ekm-search-anchor');

		var refElement = (anchorSelector !== '')
			? input.closest(anchorSelector) || input
			: input;
		
		positionRelativeTo(this._element, refElement);
	}
}